module.exports = __webpack_public_path__ + "img/protection-white.91729229.svg";